const apiBase = {
  development: "https://api.are.na/v2",
  production: "https://api.are.na/v2",
  test: "https://api.are.na/v2",
}

export { apiBase }
